import {
  Button,
  FormControl,
  FormLabel,
  Grid,
  HStack,
  Heading,
  Input,
  Select,
  Spacer,
  Stack,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackButtons from "../../Components/Button/BackButtons";
import LanguageSelect from "../../Components/Select/LanguageSelect";
import { UseAuthStore } from "../../Hooks/Zustand/store";
import LanguageStyleSelect from "../../Components/Select/LanguageStyleSelect";
import Loading from "../../Components/Loading/Loading";
import {
  addDocumentFirebase,
  getCollectionFirebase,
  getSingleDocumentFirebase,
} from "../../Apis/firebaseApi";
import { checkIdSelect } from "../../Hooks/Middleware/UserMiddleWare";

function AiCreatePage() {
  const param = useParams();

  const globalState = UseAuthStore();
  const [messageContent, setMessageContent] = useState();
  const [headlineMessage, setHeadlineMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [template, setTemplate] = useState({});
  const [data, setData] = useState({
    template: "f4nUYjPvHUX5CloGE8NQ",
    type: "text",
    category: param.content,
    socialMedia: param.name,
  });
  const navigate = useNavigate();
  console.log(message, template, "ppp");

  const toast = useToast({
    position: "top",
    align: "center",
  });

  const getDataTemplate = async () => {
    const conditions = [
      { field: "title", operator: "==", value: param.content },
    ];

    try {
      const res = await getCollectionFirebase("templates", conditions);
      setTemplate(...res);
    } catch (error) {
      console.log(error, "ini error");
    }
  };

  const handleLanguageChange = (selectedLanguage) => {
    setMessage({ ...message, language: selectedLanguage });
  };

  const handleLanguageStyleChange = (selectedStyle) => {
    setMessage({ ...message, languageStyle: selectedStyle });
  };

  console.log(param.content);

  const runAi = () => {
    if (!message.topic || !message.language) {
      return toast({
        title: "warning",
        description: "please check your topic and language",
        status: "error",
      });
    }

    const validationResult = checkIdSelect(
      globalState.currentCompany,
      globalState.currentProject
    );

    if (!validationResult.success) {
      toast(validationResult.error);
      return;
    }

    setIsLoading(true);
    let str = "";
    for (const [p, val] of Object.entries(message)) {
      str += `${p.replace("_", " ")}:\n -${val}\n`;
    }

    let newJSON = "";
    if (template.title === "headline") {
      setHeadlineMessage(template.message);
      console.log(template.message, "ini mesage");
      newJSON = `here are the 119 examples \n This Science-Backed, 4-Day Experience Unleashes Your Life’s True, Untapped, Maximum Potential  \nHow To Get ALL Of Your Sales Letters, Scripts And Webinar Slides, Emails And Ads Written (In As Little As 10 Minutes) WITHOUT Hiring An Expensive Copywriter! \nOver 156,000 Already Use This Oriental Method to Melt Off 1 lb Fat Every 48 Hours \nGet Instant Access To A Simple, Proven Webinar Framework That Has Turned HUNDREDS Of Entrepreneurs Into 'Two Comma Club' Winners! \nHow I Wake Up With An Additional $1,000 - $5,000 Per Day In My Bank Account Every Single Day \nStrange "Mouth Detox" Makes You Appear 10 Years Younger..— Whitens Teeth Up To 6 Shades In Less Than 16 Minutes... \nHow You Can Write Your Very Own Best-Selling, Cash-Inducing Book In Less Than 24 Hours… \nMake $30,000 With Your Facebook™ Group In The Next 90 Days Guaranteed \nGet Your Free Copy Of The 7 Money Models We Use To Scale Gyms To Over $100,000 Like Clockwork \nHow You Can Wake Up With An Additional $1,000-$5,000 In Your Bank Account Every Single Day \nA Proven 6-Step System to Change Your Brain & Radically Transform Your Impact, Income, Business, & Life \nDiscover how you can scale thanks to your Sales Team with Setters & Closers to generate 50-500k€/month in High Ticket sales \nONLINE MARKETING JUST GOT WAY EASIER. (at least according to the 40,000+ folks we've helped so far...) \nThe 45 Minute ‘No Pitch’ Webinar Thats Generated $238,304 In The Past 4 Weeks  WITHOUT Actually ‘Selling’ Our Program! \nSee How We Get 100-200 Group Members Per Day & Convert Them Into 40-60 High Ticket Clients Each Month \nGET DOUG'S "5 SIMPLE STEPS TO TURN YOUR PASSION INTO A 6-FIGURE ONLINE BUSINESS \nWe Will Custom Build You This EXACT Website... So You Can EARN $100 Or MORE, Every Day From Your Phone, Anywhere In The World! \nHOW TO MAKE $10,000 PER MONTH WITH AIRBNB USING OUR A.A. STRATEGY... IN THE FIRST 90 DAYS OF 2023 \nSee How I Went from a Broke Student to Making Over $100K In Profit Under 60 Days \nBuilt By A Team Responsible  For 8+ Figures In Revenue & Nearly 1M People Across Our Facebook™ Groups \n5 Mistakes Credit Repair Businesses Make That Prevent Them From Making $50K a Month \nHow Everyday People Are Using Forbidden Mind Control Psychology and Ruthless Military Tactics to Make Millions Online. \nNew Book Reveals How To Wholesale 3-5 Houses Per Month And Become Financially Free Without Using Your Cash Or Credit \nHow to make $100,000 in 2023 as a Certified Appointment Setter By simply speaking on the phone or messaging people (That's it) \nDiscover How To Go From $0 to $10,000 per month Online Business In 90 Days Or Less From Scratch \nTAKE ALL MY TOP SECRETS I USE TO MAKE 50K A MONTH SO YOU CAN WIN THE ECOM BATTLE \nThis Is EXACTLY How I Retired My Wife in 30 Days... and I'm Giving It All Away For Just $1! \nWhat If You Had a YouTube Automation Channel That Makes 31 Videos Per Month For You? \nLearn The Exact Strategy I Used To Make $125,000+ In 31 Days Selling Just One Product Online \nThe Proven Formula Used in Sales Videos, Webinars and Offline Events That Has Generated Over 8- Figures In Sales... Without Being Sleazy, Pushy or Manipulative \nGet Access To A Proven System Printers Use For Print Estimating, Tracking Jobs, PO's, Stock, Invoices, Online Orders & More... \nHOW WE GET $10,000-$15,000 PER MONTH CONSISTENTLY WHILE TRADING 2-4 HOURS PER DAY AND FOCUSING ON ONLY 1 PROVEN METHOD \nDiscover How We Source, Develop And Launch Winning Amazon Products That Generate As Much As $1,000,000 In Sales \nDiscover 5 Simple Steps To Build YOUR Own Wildly Profitable $100,000 Online Business Without ANY Product in just 1 year.. \nHow to TALK TO GIRLS and Spark ATTRACTION Within Seconds! \nBREAKING FREE FROM DIABETES. Discover The Proven Method To Reverse It Naturally.. \nFind out how one of our hidden contacts discovered TikTok's secret algorithm and exploited it to generate up to €2,000 per day by investing ZERO in advertising \nGet EVERYTHING You Need To Start Earning $1000s In Affiliate Commissions Today For FREE \nHow I Built a $5,500,000 Business from Scratch in 90 Days Starting with Zero Contacts and Just $100 \nEarn $180.00 PER SQUARE FOOT Working From Home Right In Your Own Backyard \n4 Proven "Organic" Social Media Strategies We Use To Book 30-40+ NEW Clients CONSISTENTLY \nHOW WE GENERATE $100,000 - $5,000,000 IN ADDED TOP-LINE REVENUE IN 90 DAYS \nJoin the Community Responsible for Creating the Most Pay-Per-Lead Millionaires...FOR JUST $1 \n3-Day Online Workshop Reveals How To Attract $5k Website Clients While Working 50% Less \nFind Out How To Land Your First Paying Client That Pays You $1,000 To $3,500+ In The Next 4 Weeks (Or Less) \nLearn the exact step-by-step evergreen strategies we used to scale Lions Not Sheep Apparrel from $0 - $5,000,000+ in just 12 months \nA Proven, Step-By-Step, 1-on-1 Coaching Program to Scale Your Digital Marketing Agency to $30K+/Mo \n"Weird Trick" Makes Us $513 Per HOUR & Works With ANY Affiliate Product WITHOUT EVER PROMOTING IT \nRevealed: The Secret C-P-M-A-System That Banked Me $547,260 Through Instagram™ Before I Turned 19 \nEarn 60% On WarriorPlus & JVZoo + $2,650 CASH Prizes, $19k/Month Reciprocation...With Our $10k YouTube+Traffic+Affiliate 4-in-1 NEW 2020 Software Apps \nHow Entrepreneurs, Former Pro Athletes & Dads Can Get Lean & Jacked In 90 Days (Or Less)... Even If They Have 10, 15 Or 20 Lbs To Lose \nTHE ALMOST-UNKNOWN REASON WHY 99.9% OF MEN FAIL TO ATTRACT GORGEOUS WOMEN \nWould You Like Me To Hand You The Exact Blueprint Showing What  The TOP 1% of ClickFunnels Users Are Doing Differently That The Other 99% Are Not...  ...For FREE!?! \nHow I Launch with as Little as 1 – 2 Days of Work and Convert 3-5% of Attendees Using this Fill-in-the-Blank Webinar “T.A.N.G.O.” Template Pack \nHow a Broke Kid, Living Out Of A Motel Room With 7 People, Changed His Life Forever After Discovering The ‘Mail Box Secrets’ to Making MULTI-MILLIONS \nNAVIGATE AND MAXIMIZE YOUR PART OF THE $2.2 TRILLION STIMULUS BILL \nTHE 4 STEPS TO TURN YOUR MESSAGE Into A Leads & Fame Machine For Your Business...USING ORGANIC YOUTUBE \nFlat Sale ONLY For Today - Special Offer Save Upto $300 + Free US Shipping + 60 Day Money Back Guarantee \nBAGAIMANA SAYA MENDAPAT UNTUNG Lebih dari R$10 ribu per hari, TANPA BANYAK MEMAHAMI Internet atau Meninggalkan Rumah \nNEW APP  FORCES PROFITS Of $354+ Per Day Into Our Accounts \nYou Are Free To Increase Your Leads & Sales 'Almost Like Magic,'  By Tapping Into Proven Psychological Triggers That Build Trust & Prevent Your Prospects From Ignoring You!  \nTHE 4 STEPS TO TURN YOUR MESSAGE Into A Leads & Fame Machine For Your Business... USING ORGANIC YOUTUBE \nHow To Get At Least 4 New Clients A Month Using FREE Tools You Probably Already Have… \nMy Unexpected Service That's Currently Making Me $2000 PER DAY! \nMEGA-SCALE TO 7, 8 AND 9 FIGURES FAST WITH YOUR MOST PROFITABLE CAMPAIGNS EVERYWHERE ON THE WEB \nLAUNCH, BUILD, GROW, AND MONETIZE YOUR ONLINE PRESENCE LIKE NEVER BEFORE \nAre You Ready To Get In The Room With The Savviest Marketers In The Game Doing A Combined $400MM Using The Latest Direct Response Tactics & Strategies? \nRegular guy defeats the "gurus of rehash" and discoveries teh secret to $10.000 per month in his spare time \nMake Bank From Social Media – With Less Than 1,000 Followers \nNovember 27th: Earn 60% On WarriorPlus & JVZoo + $4,100 CASH Prizes, $19k/Month Reciprocation...With Our $10k Amazon + Christmas Affiliate 5x NEW Software Suite! \nUse Our Forex Trading System From Your Phone For FIVE MINUTES A DAY To Win 96.5% Of The Time Using Our Trades. \nTHE ULTIMATE GUIDE TO MARKETING YOUR GYM Plus Over $2000 Worth Of Swipes, Tutorials And Resources \nHow My Wife Lost 20 Pounds, Shed 6 Inches, And Healed Her Diastasis Recti After Her FOURTH Baby \nFrom € 900 per month as a tire dealer to € 1,000,000 Invoiced Working from Home \nHOW TO EARN YOUR FIRST 3 CF SIGN UPS IN FIVE DAYS \nThe 3 LeadGen Strategies I Used To Auto-Close 1178 People Into My Own Downline \nWho Else Wants Up To $2,000 Cash Payments Delivered To Your Mailbox AND... Up To $16,500 In Extra Commissions On Autopilot \nEvery Tool, Strategy, and Step You Need To Build a $500 to $3,000 Per Month Side Income in 30-60 Days \n40 Years of Research Found That People With This One Quality Are More Likely to Succeed \nFinally, Discover How My Clients Are Instantly Shattering Their Limiting Beliefs That Were Putting A Ceiling On Their Revenue, Once And For All, Using 1 Simple Process That Can Take Place In As Little As 5 Mins - 100% Guaranteed! \nDiscover The Easiest Low-Tech Strategy For Coaches, Consultants & Knowledge-Based Experts To Win High Paying Clients From Your Existing Network Without Complicated Ads, Funnels, or webinars \nUnique System Banks A Total Newbie $214.83 Per Hour Using 100% Free Traffic \nBreakthrough Software “AUTOMATES” FREE Traffic, Leads & Commissions in Less Than 60 Seconds... \nDiscover How I'm Raking In An Easy $11,202 Per Day Online! \nReady To Scale Past 5 & 6 Figures By Getting Funded Up To 300k To Leverage with Our Private Profile Method™ \nHow I Finally Got An Agent, Quit My Day Job, and Made $85,000 Acting On TV... And How You Can Too! \nGive Me 3 Days Or Less And You’ll Have A... Fully-Functional, Mostly-Automated Lead Generation Website Up-And-Running And Ready To Make You Money \nFree Webinar: The NEW Way to Sell PPC With a 75% Profit Margin - That Focuses on Serving the Average Business Owner \nFree Training Reveals Powerful Viral System that generates $500+ a day on Autopilot \nHow To Eliminate BPPV Vertigo In As Little As 3 Minutes And Keep It From Coming Back \nThis Weird Method Makes $239 Per Hour With NO Videos, NO Websites And NO Paid Traffic \nDon’t Look At Buying Any Business or Franchise System Until You Read This \nExclusive Training Reveals the 3-Step Plug-and-Play System to Create a $5-10K/Month Content Agency in Just 30 Days \nMy secrets to building a  Profitable Instagram Business/Brand & Making Over $5.000 Per Month \nThe Epic “Pitch Video Weapon” Churns Out Attention Grabbing - Profit Pulling Videos in ANY Niche in 60 Mins Flat \nAccounts Are FLOODING With $798+ Commissions From Only 10 Minutes Of Work Per Day \nWe Create High-Converting Landing Page That Attracts And Sells For You (Without Paying $25,000 Or Even $10,000)

and please create Please create 30 headlines with a topic {topic} and use that 119 examples as a reference. Make sure each headline has a unique style. Write and answer all in {language} language with {languageStyle} tone, include the the benefits {benefits}, fear {fears}, time related {time_related}, character/brand competitor {character_or_brand_competitor}, location {location_related}. Change the word inside curly bracket with this data in this list: \n \n ${str}`;
      template?.message?.push({
        content: newJSON,
        role: "user",
      });
      // console.log(newArr, "yg udah dipush");
      // setHeadlineMessage(template?.message);
    } else {
      newJSON = `i want to make ${param.name} content. ${template?.message}. Change the word inside curly bracket with this data: \n \n ${str}`;
    }

    let newData = {};
    if (template.title === "headline") {
      newData = {
        ...data,
        title: message.topic,
        message: template?.message,
        projectId: globalState.currentProject,
      };
    } else {
      newData = {
        ...data,
        title: message.topic,
        message: [{ role: "user", content: newJSON }],
        projectId: globalState.currentProject,
      };
    }
    addDocumentFirebase("files", newData, globalState.currentCompany)
      .then((x) => {
        setIsLoading(false);
        navigate(`/folder-aissistant/view/${x}`);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err.message);
        toast({
          title: "Error",
          description: err.message,
          status: "error",
        });
      });

    const logRes = addDocumentFirebase(
      "logs",
      {
        activity: `create folder file for aissistant copywriting`,
        detail: { title: message.topic, message: newJSON },
        projectId: globalState.currentProject,
        uid: globalState.uid,
        type: "copywriting",
      },
      globalState.currentCompany
    );
    console.log(logRes, "log added");
  };

  const inputStyles = {
    "&::placeholder": {
      color: "gray.500",
    },
  };

  useEffect(() => {
    getDataTemplate();

    return () => {};
  }, []);

  return (
    <>
      {template.responseStyle ? (
        <Button mt="2" onClick={() => runAi()} w="full" colorScheme="green">
          Run AI
        </Button>
      ) : (
        <Stack p={[1, 1, 5]} spacing={5}>
          <HStack>
            <BackButtons />
            <Spacer />
            <Heading textTransform={"capitalize"}>
              Aissistant - {param.content} Content
            </Heading>
          </HStack>
          <Grid gap={5} templateColumns={{ base: "1fr", md: "2fr 1fr" }}>
            {param.content === "tutorial" && (
              <Stack>
                <FormControl>
                  <FormLabel>What tutorial do you want to know?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, content: e.target.value })
                    }
                    placeholder={`how to research products on Alibaba.com`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "comparing" && (
              <Stack>
                <FormControl>
                  <FormLabel>What do you want to compare</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, content: e.target.value })
                    }
                    placeholder={`why people must multitasking and not do multitasking`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "funfact" && (
              <Stack>
                <FormControl>
                  <FormLabel>Details Topic</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, details: e.target.value })
                    }
                    placeholder={`unique topics and give a recommendation for headline, script, reference video or resource`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>How Many Topic?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, amount: e.target.value })
                    }
                    placeholder={`Ten, or 5`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "headline" && (
              <Stack>
                {/* <FormControl>
                  <FormLabel>Headline Topic</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({
                        ...message,
                        headlineTopic: e.target.value,
                      })
                    }
                    placeholder={`Topic for headline`}
                  />
                </FormControl> */}
                <FormControl>
                  <FormLabel>Benefits</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, benefits: e.target.value })
                    }
                    placeholder={`$100k/ month \n1.000 cars /month \nauto pilot business`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Fears</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, fears: e.target.value })
                    }
                    placeholder={`Machine malfunctions \nRecruitments \nAfter sales`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Time related</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, time_related: e.target.value })
                    }
                    placeholder={`Setup business in 30 days \nOnly takes 5 minutes to wash a car`}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Character/Brand related</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({
                        ...message,
                        character_or_brand_competitor: e.target.value,
                      })
                    }
                    placeholder={`Mr. Wash \n5 a sec`}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel>Location related</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({
                        ...message,
                        location_related: e.target.value,
                      })
                    }
                    placeholder={`Mr. Wash \n5 a sec\nJim Carry`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "motivation" && (
              <Stack>
                <FormControl>
                  <FormLabel>Goals from the story post</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, goals: e.target.value })
                    }
                    placeholder={`share moral value from the story to audience`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Additional for content</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, additional: e.target.value })
                    }
                    placeholder={`add music recommendation`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "podcast" && (
              <Stack>
                <FormControl>
                  <FormLabel>Who is the person you want to interview</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, person: e.target.value })
                    }
                    placeholder={`Cooker, Doctor, Teacher`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>How Many Question You Want To Ask?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, total: e.target.value })
                    }
                    placeholder={`ten, or 15`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "quiz" && (
              <Stack>
                <FormControl>
                  <FormLabel>Additional Detail For Quiz</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, additional: e.target.value })
                    }
                    placeholder={`Make the the quiz difficulty from easy to hard`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "GoogleAds" && (
              <Stack>
                <FormControl>
                  <FormLabel>Company Name</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, company: e.target.value })
                    }
                    placeholder={`Your Company Name. Ex: Deoapp Techno`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Company Url</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, companyUrl: e.target.value })
                    }
                    placeholder={`Your Company Url. Ex: ai.deoapp.com`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Keywords</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, keyword: e.target.value })
                    }
                    placeholder={`Keyword related to your ads and companies. Separated by comma. Ex: Artificial, Technology, Computer`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Target Audience</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, targetAudience: e.target.value })
                    }
                    placeholder={`Target Audience for the ads. Ex: Middle Age man, rich people who interested in technology, technopreneur person`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Company Product/Service Description</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, description: e.target.value })
                    }
                    placeholder={`A brief description about your company products or services`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "review" && (
              <Stack>
                <FormControl>
                  <FormLabel>What do you want to review about?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, detailTopic: e.target.value })
                    }
                    placeholder={`example: Best ramen in Nagoya City, or Indonesian unique culture`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>
                    What word or sentence that should be in the script?
                  </FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({
                        ...message,
                        highlightedWord: e.target.value,
                      })
                    }
                    placeholder={`good taste, delicious and must try`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Additional Detail</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, additional: e.target.value })
                    }
                    placeholder={`recommend music or image for the topic`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>How Long</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, duration: e.target.value })
                    }
                    placeholder={`1 minute, 2 minute`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "story" && (
              <Stack>
                <FormControl>
                  <FormLabel>What story do you want to know?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, story: e.target.value })
                    }
                    placeholder={`someone who is struggling with a short memory and the way she/he can handle the problem`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Additional Story Detail</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, additional: e.target.value })
                    }
                    placeholder={`tell me the reason why the brain is losing memory`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>What do you want to do from that story?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, goals: e.target.value })
                    }
                    placeholder={`share moral values from the story`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "caption" && (
              <Stack>
                <FormControl>
                  <FormLabel>What caption do you want?</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, content: e.target.value })
                    }
                    placeholder={`common caption, caption with hastag`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>
                    What do you want audience to do with your content?
                  </FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, additional: e.target.value })
                    }
                    placeholder={`example: share and comment, tag other user etc`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "Facebook Ads Primary Text" && (
              <Stack>
                <FormControl>
                  <FormLabel>Target Audience</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, targetAudience: e.target.value })
                    }
                    placeholder={`Target Audience for the ads. Ex: entrepreneurs and business owners`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Company Product/Service Description</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, description: e.target.value })
                    }
                    placeholder={`A brief description about your company products or services Ex : autopilot business workshop`}
                  />
                </FormControl>
              </Stack>
            )}

            {param.content === "User Persona For Bussiness Market" && (
              <Stack>
                <FormControl>
                  <FormLabel>Describe Your Bussiness</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, description: e.target.value })
                    }
                    placeholder={`describe your company as complete as possible`}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Domicile</FormLabel>
                  <Textarea
                    bgColor="white"
                    color="black"
                    sx={inputStyles}
                    resize="none"
                    onChange={(e) =>
                      setMessage({ ...message, location: e.target.value })
                    }
                    placeholder={`Input your company current locations`}
                  />
                </FormControl>
              </Stack>
            )}

            <Stack>
              <FormControl>
                <FormLabel>Topic</FormLabel>
                <Input
                  bgColor="white"
                  color="black"
                  sx={inputStyles}
                  type="text"
                  placeholder="Carwash"
                  onChange={(e) =>
                    setMessage({ ...message, topic: e.target.value })
                  }
                />
              </FormControl>
              <LanguageSelect onChange={handleLanguageChange} />
              <LanguageStyleSelect onChange={handleLanguageStyleChange} />

              {isLoading ? (
                <Loading />
              ) : (
                <Button
                  mt="2"
                  onClick={() => runAi()}
                  w="full"
                  colorScheme="green"
                >
                  Run AI
                </Button>
              )}
            </Stack>
          </Grid>
        </Stack>
      )}
    </>
  );
}

export default AiCreatePage;
